import React from 'react';
import { ModalButtonSave, ModalButtonUpdate } from '../../constant';
import { FormCatLoteMediosSanitaria } from './FormCatLoteMediosSanitaria';
import { Dialog } from 'primereact/dialog';

export const ModalCatLoteMediosSanitaria = (props) => {
    const{
        method, modalTitle, loading, modal,
        handleInputChange, saveCreate, saveUpdate,
        validaciones, descripcion,n_lote,closeDialog
    }=props;


    return (
         <Dialog 
            header={modalTitle}
            visible={modal}
            onHide={closeDialog}
            closable={true}
            modal
            blockScroll
            className='medium-dialog'
        >
            {
                method === "create"
                ?<FormCatLoteMediosSanitaria
                    button = {ModalButtonSave}
                    {...{closeDialog, loading, handleInputChange, validaciones, methodAction: saveCreate,}}
                />
                :
                (method === "update")
                ?
                <FormCatLoteMediosSanitaria
                    button={ModalButtonUpdate}
                    {...{ closeDialog, loading, handleInputChange, validaciones, methodAction: saveUpdate, descripcion,n_lote}}
                />
                :
               null
            }
        </Dialog>
    )
}